<template>
  <b-modal
    v-model="show"
    @shown="initForm()"
    @hide="resetForm()"
    ref="shareProfileModal"
    size="md"
    centered
    hide-footer
  >
    <template #modal-title>
      <h3 class="font-weight-bold">Share my Profile to</h3>
    </template>

    <b-overlay :show="isLoading" rounded="sm">
      <template #overlay>
        <div class="text-center">
          <digger-loader />
        </div>
      </template>
      <b-form ref="form" @submit.prevent="onSubmit">
        <b-col class="px-0">
          <!-- Destination Email -->
          <b-form-group>
            <label>Destination Email</label>
            <b-form-input
              v-model="form.email"
              :state="state.email"
              type="email"
              clearable
              autofocus
            />
            <b-form-invalid-feedback :state="state.email">
              {{ errors.email }}
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- Consent Checkbox -->
          <b-form-group>
            <b-form-checkbox v-model="form.is_aware" required>
              I am aware that i am about to share my personal information to the
              destination email
            </b-form-checkbox>
            <b-form-invalid-feedback :state="state.is_aware">
              {{ errors.is_aware }}
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- Message -->
          <div class="mt-5 text-center">
            <span v-if="isSuccess" class="text-success"
              >Profile shared successfully!</span
            >
            <span v-if="isError" class="text-danger">
              Oops.. Something went wrong, please try again
            </span>
          </div>

          <!-- Submit -->
          <b-button type="submit" variant="primary" class="w-100 mt-3 mb-3">
            SHARE PROFILE
          </b-button>
        </b-col>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex/dist/vuex.common.js'
import { normalizeEmail, isValidEmail } from '@/utils/emailPolicy'

export default {
  name: 'ShareProfileModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    defaultEmail: { type: String },
  },

  data() {
    return {
      isLoading: false,

      form: {
        email: null,
        is_aware: null,
      },

      state: {
        email: null,
        is_aware: null,
      },

      errors: {
        email: 'Invalid email address!!',
        is_aware: 'We need your consent to share Profile',
      },

      isSuccess: false,
      isError: false,
    }
  },

  computed: {
    show: {
      get() {
        return this.showModal
      },
      set() {
        this.$emit('onCloseShareProfileModal')
      },
    },
  },

  watch: {
    'form.email': _.debounce(function () {
      this.state.email = this.form.email ? isValidEmail(this.form.email) : null
    }, 100),

    'form.is_aware'(val) {
      this.state.is_aware = val === null ? this.form.is_aware : null
    },
  },

  methods: {
    ...mapActions({
      shareProfileByEmail: 'profile/shareByEmail',
    }),

    onSubmit() {
      this.form.email = normalizeEmail(this.form.email)
      const isValid = isValidEmail(this.form.email)
      const isValidAware = !!this.form.is_aware

      this.state.email = isValid
      this.state.is_aware = isValidAware

      if (!isValid || !isValidAware) return

      this.isLoading = true
      this.isSuccess = false
      this.isError = false

      this.shareProfileByEmail(this.form.email)
        .then((res) => (this.isSuccess = true))
        .catch(() => (this.isError = true))
        .finally(() => (this.isLoading = false))
    },

    initForm() {
      this.form.email = this.defaultEmail
      this.form.is_aware = false
    },

    resetForm() {
      this.form.email = null
      this.form.is_aware = null

      this.isSuccess = false
      this.isError = false
    },
  },
}
</script>
